import React from 'react';

export const IconSmallArrowLineLeftLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M7.414 13l4.293 4.293-1.414 1.414-6-6L3.586 12l.707-.707 6-6 1.414 1.414L7.414 11H20v2H7.414z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
